import React from 'react';
import styled, { css } from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Row, Spin } from 'antd';

type Props = {
  color?: string;
  text?: string | null;
  noText?: boolean;
  verticallyCentered?: boolean;
};

const BigIcon = styled(Spin)`
  font-size: 50px;
`;

const verticallyCenteredMixin = css`
  display: flex;
  min-height: inherit;
  height: inherit;
  flex-direction: column;
  justify-content: space-around;
`;

const LoadingWrapper = styled(({ verticallyCentered, ...rest }) => (
  <div {...rest} />
))<Props>`
  & .loading-text {
    margin-top: 20px;
    font-size: 20px;
  }
  color: ${(props) => props.color};
  ${(props: Props) => props.verticallyCentered && verticallyCenteredMixin};
`;

const Loading: React.FC<Props> = ({
  text = '',
  noText = false,
  verticallyCentered = false,
  color = '#f4f5f5',
}) => (
  <LoadingWrapper color={color} verticallyCentered={verticallyCentered}>
    <div data-testid="loading">
      <Row justify="center">
        <BigIcon />
      </Row>

      {!noText && (
        <Row justify="center" className="loading-text">
          {text || <FormattedMessage defaultMessage="Loading content..." />}
        </Row>
      )}
    </div>
  </LoadingWrapper>
);

export default Loading;
